import React, { Component } from 'react'
import classNames from 'classnames'
import { getLocalFilePath } from '../js/getLocalFilePath'

class ZoomButtons extends Component {
  render () {
    const { onZoomIn, onZoomOut, onReset, onFullscreen } = this.props

    return (
      <div className={'buttons'}>
        <div className={classNames('zoom-button out')} onClick={onZoomOut}>
          <i className={'icon-minus'} title={'Zoom out'}/>
        </div>
        <div className={classNames('zoom-button in')} onClick={onZoomIn}>
          <img alt="Zoom in" title={'Zoom in'} src={ getLocalFilePath('/images/plus.png') }/>
        </div>
        <div className={classNames('zoom-button reset')} onClick={onReset}>
          <img alt="Reset zoom" title={'Reset zoom'} src={ getLocalFilePath('/images/reset.png') }/>
        </div>
        <div className={classNames('zoom-button full')} onClick={onFullscreen}>
          <img alt="Fullscreen" title={'Fullscreen'} src={ getLocalFilePath('/images/maximize.png') }/>
        </div>
      </div>
    )
  }
}

export default ZoomButtons
